import React from "react";
import ConsultationHealthWorker from "../../components/Users/HealthWorkersUsers/healthWorker/ConsultationHealthWorker";

const BreakdownContainer = ({ contract_summary }) => {
  const chartData = contract_summary?.chart_data || []; 

  console.log(chartData, 'chart data')

  return (
    <div className="sm:flex justify-between mb-2 sm:mb-[15px]">
      <div className="w-[100%] sm:w-[65%] lg:w-[100%]">
        {chartData.length > 0 ? (
          <ConsultationHealthWorker chartData={chartData} />
        ) : (
          <p>Loading chart data...</p>
        )}
      </div>
    </div>
  );
};

export default BreakdownContainer;
